export default function TrustBar() {
  const items = [
    { icon: 'ri-refresh-line', label: 'Updated Weekly' },
    { icon: 'ri-database-2-line', label: '1000+ Items Indexed' },
    { icon: 'ri-global-line', label: 'Multi-Agent Coverage' },
    { icon: 'ri-search-eye-line', label: 'SEO Verified' },
  ];

  return (
    <section className="bg-background-100 py-4 md:py-5">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
          {items.map((item) => (
            <div key={item.label} className="flex items-center gap-3 justify-center">
              <div className="w-8 h-8 flex items-center justify-center text-accent-500">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}